import React from 'react';
import { CasesIdentityVerificationV1GenerateIdFormContainerIdentityVerificationCaseV1Document } from '../../../../../../generated';
import { useLazyQuery } from '@apollo/client';
import { AuthResult, AzureBlobResponse } from '../../../../../shared/file-upload/azure-upload';
import { pdf } from '@react-pdf/renderer';
import IdFormBlank from '../../../../../shared/pdf-generation/pdf-pages/id-form/id-form-blank';
import GeneratePdfFormButton from '../../../../../shared/pdf-generation/generate-pdf-form-button';
import { message } from 'antd';
import dayjs from 'dayjs';
import { UploadFile } from 'antd/lib';
import { DATE_FORMAT } from '../../../../../../constants';
import { FormatDate } from '../../../../../../constants';


interface GenerateIdFormContainerProps {
  authorizeRequest: (file: File) => Promise<AuthResult>;
  onSuccess: (response: AzureBlobResponse, file?: UploadFile) => Promise<void>;
  isProcessing: boolean;
  onStartPdfGeneration?: () => void;
  isProcessingUploadingFile?: boolean;
  caseId: string;
  setIsEditing?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const GenerateIdFormContainer: React.FC<GenerateIdFormContainerProps> = (props) => {

  const onSuccess = async (response: AzureBlobResponse) => {
    await props.onSuccess(response);
    message.success('ID Form generated successfully');
    props.setIsEditing && props.setIsEditing(false);
  };

  const [getPdfData,{ loading: caseLoading }]  = useLazyQuery(CasesIdentityVerificationV1GenerateIdFormContainerIdentityVerificationCaseV1Document, {
    variables: {
      identityVerificationCaseV1Id: props.caseId
    },
    fetchPolicy: 'network-only'
  });

  const getGenerateIdFormData = async () => {
    props.onStartPdfGeneration && props.onStartPdfGeneration();
    const pdfData = await getPdfData()

    const caseData = pdfData.data?.identityVerificationCaseV1;

      const blobUrls: { [key: string]: string | undefined } = {};
  
      caseData?.files?.forEach((file) => {
        const fileName = file?.name?.split('/').pop();
        if (fileName) {
          blobUrls[fileName] = file?.url;
        }
      });
  
      const photoUrl = blobUrls['photo.jpg'];
      const passportUrl = blobUrls['passport.jpg'];

      const submissionDeadline = dayjs().add(3, 'month').format(DATE_FORMAT);

      const combinedData = {
        applicantId: caseData?.applicant?.id,
        caseId: caseData?.id,
        dateOfBirth: caseData?.applicant?.personalInformation?.identityDetails?.dateOfBirth,
        gender: caseData?.applicant?.personalInformation?.identityDetails?.gender,
        lastName: caseData?.applicant?.personalInformation?.identityDetails?.lastName,
        restOfName: caseData?.applicant?.personalInformation?.identityDetails?.restOfName,
        photoUrl: photoUrl,
        passportUrl: passportUrl,
        submissionDeadline: caseData?.expirationEligibleAt
        ? FormatDate(caseData.expirationEligibleAt)
        : submissionDeadline           
      };
  
      return { combinedData };
 
  };

  const generateIdFormPdf = async (data: any): Promise<File> => {
    if (!data.dateOfBirth || !data.gender || !data.lastName || !data.restOfName || !data.photoUrl || !data.passportUrl || !data.applicantId || !data.caseId || !data.submissionDeadline) {
      throw new Error('Missing data to generate ID form');
    }
    const pdfBlob = await pdf(<IdFormBlank data={data} />).toBlob();
    return new File([pdfBlob], 'id-form.pdf', { type: 'application/pdf' });
  };

  return (
    <GeneratePdfFormButton isProcessingUploadingFile={props.isProcessingUploadingFile} authorizeRequest={props.authorizeRequest} onSuccess={onSuccess} generateFormPdf={generateIdFormPdf} generateFormPdfData={getGenerateIdFormData} isLoading={props.isProcessing || caseLoading}/>
  );
};
